import $ from "jquery";
import ScrollMagic from "scrollmagic";

function initPinnedImages() {
  let instances = [...document.querySelectorAll('.scroll-pin')]

  instances.forEach((pinnedContainer) => {
    let pinnedImageScrollController = new ScrollMagic.Controller()

    let pinnedImage = pinnedContainer.querySelector('.scroll-pin__pinned-content')
    let pinnedContainerHeight = pinnedContainer.clientHeight
    let imgHeight = pinnedImage.clientHeight
    let duration = pinnedContainerHeight - imgHeight
    let headerOffset = -90

    new ScrollMagic.Scene({
      triggerElement: pinnedContainer,
      triggerHook: 0,
      offset: headerOffset,
      duration: duration,
    })
    .setPin(pinnedImage)
    .addTo(pinnedImageScrollController)
  })
}

$(function () {
  // Initialize with a slight delay to let all the other
  // content animation initializations finish
  // pinning only on desktop
  if (window.innerWidth > 768) {
    window.setTimeout(function(){
      initPinnedImages()
    }, 1000)
  }
});
